<div class="mat-modal-container">
  <div class="intent-wrapper">
  <div class="success-modal" *ngIf="isSuccess == true">
    <button class="close-btn" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    <app-lead-success></app-lead-success>
  </div>
  <div *ngIf="isSuccess == false">
    <button class="close-btn" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    <div class="content-section">
      <img loading="lazy" data-src="/assets/images/exit-intent-icon.png" alt="Exit intent icon" />
      <h2>Confused?</h2>
      <p>Do you need help with Starting your Fundraiser?<br />
        Our personal fundraiser expert is waiting to get you started!</p>
      <form class="exit-form" [formGroup]="leadForm" (ngSubmit)="lead()">
        <app-input [group]="leadForm" [control]="name" [placeHolder]="formInfo.name.placeholder"
          [errorMessage]="formInfo.name.error" [info]="false" icon="icon-user"></app-input>
        <app-intl-input class="intl-input-container" [group]="leadForm" [control]="mobile" [hideSuffixIcon]="false">
        </app-intl-input>
        <div>
          <app-button mat-raised-button type="submit" label="Get a call" class="call-btn"></app-button>
        </div>
      </form>
    </div>
    <div class="faqs">
      <p>Helpful links:</p>
      <div class="helpfull-links">
        <div>
          <a rel="noopener" href="https://support.ketto.org/hc/en-us/articles/360009675313-Will-Ketto-assist-me-" target="_blank">Will Ketto assist me?</a>
          <a rel="noopener" href="https://support.ketto.org/hc/en-us/articles/360009561994-How-long-can-I-run-a-fundraising-page-on-Ketto-"
            target="_blank" class="no-margin">How long can I run a fundraising page on Ketto?</a>
        </div>
        <div>
          <a rel="noopener" href="https://support.ketto.org/hc/en-us/articles/360009562274-How-do-I-find-my-campaign-manager-"
            target="_blank">How do I find my campaign manager?</a>
          <a rel="noopener" href="https://support.ketto.org/hc/en-us/articles/360009562034-Can-I-change-the-goal-amount-"
            target="_blank" class="no-margin">Can I change the goal amount?
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
